<div class="d-flex flex-row align-items-center ml-3 mr-3">
    <app-content-header [historyBack]="false" (backEvent)="onBack()" [headline]="'integration_apps_marketplace_headline' | i18next"></app-content-header>
</div>
<app-filter (searchFilterChanged)="filter($event)" [placeholder]="'integration_apps_search_placeholder' | i18next"></app-filter>

@if (preselectedSubId) {
  <div class="d-flex flex-row ml-3 mb-4">
    <span>{{ 'integration_apps_preselected_subscription_info' | i18next }}</span>&nbsp;
    <span><b>[{{ preselectedSubId }}] {{ preselectedSubName }}</b></span>
    <span>:</span>
  </div>
}

@if (marketplaceAppsToDisplay && marketplaceAppsToDisplay.length === 0) {
  <app-no-content-message t="no_marketplace_integration_apps"></app-no-content-message>
}

<div class="row align-items-stretch mt-2">
    @for (app of marketplaceAppsToDisplay; track app.uuid) {
      <app-integration-apps-card class="col-xs-12 col-md-6 col-lg-6 mb-3" [integrationApp]="app" [isAlreadyInstalled]="isAlreadyInstalled(app.uuid)" [preselectedSubId]="preselectedSubId" [preselectedSubName]="preselectedSubName"></app-integration-apps-card>
    }
</div>